import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import { Icon } from '../../../../../common/html/icon'
import { Tooltip } from '../../../../../common/tooltip'
import { isInValidValue, valToPercent } from '../../../../../helpers/value'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  handleIconDownload,
} from '../../helper'
import { CHARTS } from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const Trend = ({ isDynamicReport, id, check = [], isDownloadComponent }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const charts = CHARTS.filter(
    ({ dataKey }) => !isDynamicReport || check.includes(dataKey),
  )

  const isH100 = charts.length >= 3

  return (
    <div
      style={{
        height: isDownloadComponent
          ? '100%'
          : getStyleHeightContainer(
              isDynamicReport,
              isNoData,
              isH100 ? 332 : 332 / 2,
            ),
      }}
      className="dFlex flexWrap"
    >
      {charts.map((chart, index) => {
        return (
          <div
            key={index}
            className={`${isH100 ? 'h50' : 'h100'} w50 pt2 pb2 flexColumn ${
              index % 2 === 0 ? 'pr2' : 'pl2'
            }`}
          >
            <div className="fw600 pb1 dFlex alignItemsCenter">
              <span>{indicatorById[chart.dataKey]?.ratioName}</span>
              {!isDynamicReport &&
                !isDownloadComponent &&
                chart.tooltipContent && (
                  <Tooltip tooltipContent={chart.tooltipContent}>
                    <Icon
                      className="icon-info-circle ml1"
                      style={{ color: '#9C9C9C' }}
                    />
                  </Tooltip>
                )}
            </div>
            <ChartContainer
              data={dataByTrend}
              width="100%"
              height="100%"
              margin={{
                top: 10,
                bottom: 0,
                left: isDownloadComponent ? 20 : 0,
                right: 0,
              }}
              xAxis={[
                {
                  dataKey: 'year',
                  tickMargin: 3,
                  height: 20,
                  type: 'category',
                  tickFormatter: (year) => '‘' + String(year).slice(2, 4),
                },
              ]}
              yAxis={[
                {
                  yAxisId: 'left',
                  dataKeys: [chart.dataKey],
                  isBarChart: true,
                  tickFormatter: (val) => valToPercent(val, locale),
                },
              ]}
              tooltip={{
                cursor: false,
                schema: {
                  content: [
                    {
                      dataKey: chart.dataKey,
                      label: I18n.t(chart.title),
                      formatValue: (value) => valToPercent(value, locale),
                    },
                  ],
                },
              }}
            >
              <Bar
                yAxisId="left"
                dataKey={chart.dataKey}
                fill="transparent"
                label={<CustomizedLabel fill={chart.color} />}
                showLabelEmpty={() => {
                  return false
                }}
              />
            </ChartContainer>
          </div>
        )
      })}
    </div>
  )
}

const CustomizedLabel = (props) => {
  const {
    x,
    y,
    width,
    fill,
    index,
    value,
    barProps: { data },
  } = props

  const background = data[index].background

  if (isInValidValue(value)) {
    return (
      <line
        x1={background.x + background.width / 2}
        y1={background.y}
        x2={background.x + background.width / 2}
        y2={background.y + background.height}
        stroke={fill}
      />
    )
  }

  return (
    <>
      <line
        x1={background.x + background.width / 2}
        y1={background.y}
        x2={background.x + background.width / 2}
        y2={background.y + background.height}
        stroke={fill}
      />
      <circle cx={x + width / 2} cy={y} r="4" fill={fill} />
    </>
  )
}

export default Trend
